// @ts-nocheck
import { Navigate } from "react-router-dom";

function Illustration() {
  return <Navigate to="/sign-up" replace />;
}

export default Illustration;
